<div class="container mt-7 text-center bg-white">
  <div class="shadow-lg p-4 custom-background" role="alert">
    <i class="fas fa-check-circle fa-3x mb-3 text-success"></i>
    <h4 class="alert-heading">Form Submitted Successfully!</h4>
    <p class="text-dark">
      Your organization form has been submitted successfully.<br>
      We will review the details and get back to you soon.<br><br>
      All added contacts will receive an email with a link to complete passport verification.<br>
      If any contact does not have a passport, they will need to contact NHC directly to be manually verified.
    </p>
  </div>
</div>
